module.exports = __webpack_public_path__ + "img/6.9d90014d.png";